import React, { FC } from "react"
import { FleLayout } from "components/views/fle/FleLayout"
import { SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import { BodySmall } from "components/views/atoms/Bodies"
import { TextLink } from "components/views/atoms/links/TextLink"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const RegisterError: FC = () => (
  <FleLayout modal={null}>
    <SwitchH2ToBodyLarge>{`Something’s not working`}</SwitchH2ToBodyLarge>
    <Spacer height={1} />
    <BodySmall color="black-80">
      {l`We weren't able to activate your account. Try clicking the unique 
      activation link in your email. Still not working? Contact us at `}
      <TextLink underlineColor="black-80" to="mailto:support@get-carrot.com">
        {l`support@get-carrot.com`}
      </TextLink>
      {l`.`}
    </BodySmall>
  </FleLayout>
)

export { RegisterError }
